import { useState, useEffect } from 'react'
import { getGroupsAPI } from '../services/division'

function UseGroups(orgId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      orgId,
      searchs
    }
    const getData = async () => {
      const result = await getGroupsAPI(param)
      if (!result) return
      if (result.status) {
        const newData =
          result.result &&
          result.result.map((d, i) => {
            return {
              value: d.id,
              label: `${d.division_en} (${d.division})`,
              count_emp: d.count_emp,
              data: d.division
            }
          })

        setData(newData)
      }
    }
    if (orgId) {
      getData()
    }
  }, [orgId, searchs])

  return data
}

export default UseGroups
